<template>
  <div>
    <a
      v-if="!expanded"
      :class="{ btn: true, 'btn-link': true, [btnClass]: true }"
      @click="expanded = true"
      @keyup.enter="expanded = true"
    >
      <i class="glyphicon glyphicon-plus" /> Add Project...
    </a>
    <ValidationObserver v-else v-slot="{ invalid, fields }" class="form-inline" tag="form">
      <div class="form-group">
        <div class="input-group">
          <label v-if="longer" class="input-group-addon hidden-xs"> Enter project name: </label>
          <label v-else class="input-group-addon hidden-xs"> Name: </label>
          <InputValidated
            ref="inputBox"
            v-model="name"
            name="Project name"
            rules="min:1"
            :fields="fields"
            placeholder="Project Name"
            class="longer"
          />
          <div class="input-group-btn">
            <button
              type="submit"
              :class="{ btn: true, 'btn-primary': true, disabled: invalid || !name }"
              :disabled="invalid || !name"
              @click.prevent="create"
              @keyup.enter="create"
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { call } from 'vuex-pathify';
import InputValidated from '../InputValidated.vue';

export default {
  name: 'ProjectCreate',
  components: {
    InputValidated,
  },
  props: {
    initExpanded: {
      type: Boolean,
      default: false,
    },
    orgId: {
      type: String,
      required: false,
      default: '',
    },
    btnClass: {
      type: String,
      required: false,
      default: '',
    },
    initName: {
      type: String,
      required: false,
      default: '',
    },
    longer: {
      type: Boolean,
      required: false,
      default: false,
    },
    focusOnMount: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      expanded: this.initExpanded,
      name: this.initName,
    };
  },
  watch: {
    expanded(val) {
      if (val) {
        this.$nextTick(() => {
          this.focusInput();
        });
      }
    },
  },
  mounted() {
    if (this.expanded && this.focusOnMount) {
      this.focusInput();
    }
  },
  methods: {
    async create() {
      let proj = null;
      if (this.orgId) {
        proj = await this.createOrgProject({
          orgId: this.orgId,
          data: { name: this.name },
        });
      } else {
        proj = await this.createNoOrgProject({
          name: this.name,
        });
        // returns a ProjectAccess, so get actual project
        proj = proj.project;
      }
      this.name = '';
      this.expanded = this.initExpanded;
      this.$emit('project-created', proj.id);
    },
    focusInput() {
      this.$refs.inputBox.$el.focus();
      this.$nextTick(() => {
        this.$refs.inputBox.$el.select();
      });
    },
    createOrgProject: call('admin/createProject'),
    createNoOrgProject: call('account2/createProject'),
  },
};
</script>

<style scoped>
.longer {
  min-width: 360px;
}
</style>
